// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._2awVMqYUV4MjBeyZ8EoJ0X{height:100vh;overflow:auto}\n", "",{"version":3,"sources":["webpack://src/client/pages/me/pages/notification/notification-news/style.module.scss"],"names":[],"mappings":"AAEA,yBAGI,YAAa,CACb,aAAc","sourcesContent":["@import '../../../../../base.scss';\n\n.NotificationPage{\n    // background-color: #f6f6f6;\n    // background-image: linear-gradient(#f6f6f6, #fff);\n    height: 100vh;\n    overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"NotificationPage": "_2awVMqYUV4MjBeyZ8EoJ0X"
};
module.exports = ___CSS_LOADER_EXPORT___;
